function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.27 7.835c.53.048.99-.346 1.035-.872.045-.526-.345-.99-.871-1.035-.309-.026-.623-.04-.934-.04-6.065 0-11 5.02-11 11.188 0 .528.428.957.957.957.528 0 .956-.429.956-.957 0-5.114 4.076-9.274 9.087-9.274.257 0 .516.01.77.033m7.265 1.6c-.357-.389-.962-.414-1.352-.056-.388.357-.414.962-.056 1.351 1.586 1.725 2.46 3.979 2.46 6.346 0 .528.428.957.956.957.529 0 .957-.429.957-.957 0-2.848-1.053-5.561-2.965-7.64m-1.622-2.907l-4.634 9.988c-.408 1.025-1.12 1.635-1.91 1.635-.639 0-1.202-.325-1.505-.87-.34-.613-.303-1.39.095-2.03l6.064-9.744c.3-.483.925-.649 1.425-.379s.704.884.465 1.4"
});

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.00d1d5f2.svg";
export { ForwardRef as ReactComponent };